import type { PaginateAppointmentsDTO } from '@bb/domain/dist/types';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type PaginateAppointmentsOptions = {
  filter?: 'all' | 'feedback' | 'completed' | 'upcoming';
  limit?: number;
  listingId: string;
  page?: number;
  sortBy?: string;
  includeSignatures?: boolean;
};

const paginateAppointments = async ({
  filter,
  limit,
  page = 0,
  sortBy,
  listingId,
  includeSignatures,
}: PaginateAppointmentsOptions) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/appointments/paginate`,
    method: 'get',
    params: {
      filter,
      limit,
      // BE starts counting from 1
      page: page + 1,
      sortBy,
      includeSignatures,
    },
  };

  const { data } = await axios.request<PaginateAppointmentsDTO>(config);
  return data;
};

export default paginateAppointments;
